var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHtlKidsClubFilled = function SvgHtlKidsClubFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.007 15a.995.995 0 0 1-.39-.079A1 1 0 0 1 3 13.998v-8h.007a.98.98 0 0 1 .292-.706l3.993-4.016A.995.995 0 0 1 8 .976a1 1 0 0 1 .709.3l3.992 4.016a.978.978 0 0 1 .292.721v.867c.005.04.007.08.007.12v7a1 1 0 0 1-1 1H4.007Zm3.56-7.016-1.613 4.172a.5.5 0 0 0 .932.362l.393-1.017h1.5l.392 1.016a.5.5 0 0 0 .933-.359L8.5 7.981a.5.5 0 0 0-.933 0v.003Zm4.43-1.986-3.99-4.017-3.991 4.017h7.98Zm-3.6 4.5h-.732l.367-.949.365.947v.002Z"
  })));
};
export default SvgHtlKidsClubFilled;